/* ==========================================================================
   AURA — HEADER SEARCH (inline)
   The search uses a plain <details> (not Dawn's <details-modal>), so opening it
   does NOT lock page scroll, trap focus, or dim the page. This script:
     · exposes the header's bottom edge as --aura-header-bottom (panel anchor)
     · focuses the input when the field opens (type straight away)
     · closes the field on outside-click, Esc, or the × button
   ========================================================================== */
(function () {

  function headerBottom() {
    const header =
      document.querySelector('.section-header') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('header');
    if (!header) return 0;
    return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
  }

  function setVar() {
    document.documentElement.style.setProperty(
      '--aura-header-bottom', headerBottom() + 'px'
    );
  }

  function closeAll(except) {
    document.querySelectorAll('.aura-search details[open]').forEach((d) => {
      if (d !== except) d.open = false;
    });
  }

  /* ---------- empty-query discovery panel (bestsellers + popular searches) ----
     Fetched once, ever, no matter how many times any of the (up to three)
     header search instances is opened — mirrors Dawn's own predictive-search
     cache, which is already shared across every <predictive-search> on the
     page. Never re-requested. */
  let discoveryHTML = null;
  let discoveryPromise = null;

  function applyDiscovery() {
    if (!discoveryHTML) return;
    const doc = new DOMParser().parseFromString(discoveryHTML, 'text/html');
    const inner = doc.querySelector('[data-search-discovery-content]');
    if (!inner) return;
    document.querySelectorAll('[data-search-discovery]').forEach((el) => {
      if (el.dataset.filled) return;
      el.innerHTML = inner.innerHTML;
      el.dataset.filled = '1';
      el.removeAttribute('hidden');
    });
  }

  function loadDiscovery() {
    if (discoveryHTML) { applyDiscovery(); return; }
    if (discoveryPromise) return;
    discoveryPromise = fetch(`${window.location.pathname}?sections=aura-search-discovery`)
      .then((res) => res.json())
      .then((sections) => {
        discoveryHTML = sections['aura-search-discovery'] || '';
        applyDiscovery();
      })
      .catch(() => {
        discoveryPromise = null; // allow a retry on the next open if the fetch failed
      });
  }

  document.addEventListener('DOMContentLoaded', () => {
    setVar();
    window.addEventListener('resize', setVar, { passive: true });
    window.addEventListener('scroll', setVar, { passive: true });

    // Reflect "a search is open" on <html> so mobile can swap the nav bar for a
    // full-width search bar (see aura-search.css). Desktop ignores the class.
    function syncOpenState() {
      const open = document.querySelector('.aura-search details[open]');
      document.documentElement.classList.toggle('aura-search-open', !!open);
    }

    // Focus the input the moment the field opens.
    document.querySelectorAll('.aura-search details').forEach((details) => {
      details.addEventListener('toggle', () => {
        syncOpenState();
        if (!details.open) return;
        setVar();
        loadDiscovery();
        const input = details.querySelector('input[type="search"]');
        if (input) setTimeout(() => input.focus(), 60);
      });
    });

    // The persistent "bar" variant has no <details> to toggle — it's always
    // open, so its own trigger for the discovery panel is focusing the input.
    // Harmless to also listen here for the "toggle" variant's input: loadDiscovery()
    // is idempotent, so whichever event fires first wins.
    document.querySelectorAll('.aura-search__input').forEach((input) => {
      input.addEventListener('focus', loadDiscovery);
    });

    // The × close button (where shown) collapses its own field.
    document.querySelectorAll('.aura-search__close').forEach((btn) => {
      btn.addEventListener('click', () => {
        const wrap = btn.closest('.aura-search');
        const details = wrap && wrap.querySelector('details');
        if (details) details.open = false;
      });
    });

    // Click anywhere outside an open field → close it.
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.aura-search')) closeAll();
    });

    // Escape → close the open field.
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const open = document.querySelector('.aura-search details[open]');
      if (open) open.open = false;
    });
  });

})();
